import "./List.css";

import React from "react";
import { Link } from "react-router-dom";

import pin from "../images/svmappin.png";
import disabledPin from "../images/svmappindisable.png";

const ChannelList = ({ channels, onHover }) => (
  <div className="channel-list">
    {channels.map((channel, i) => (
      <Link
        to={`/channel/${channel.id}`}
        key={i}
        onMouseOver={() => onHover(channel)}
      >
        <div className="list-item">
          <img
            alt=""
            src={channel.status && channel.status.active ? pin : disabledPin}
          />
          <div style={{ flexGrow: 1 }}>{channel.location.name}</div>
          <div>{`${Math.round(channel.distance)}km away`}</div>
        </div>
      </Link>
    ))}
  </div>
);

export default ChannelList;
